import LogoAktiv from "@/images/brands/aktiv.svg";
import LogoAttentus from "@/images/brands/attentus.svg";
import LogoEie from "@/images/brands/eie.svg";
import LogoKrogsveen from "@/images/brands/krogsveen.svg";
import LogoNOEO from "@/images/brands/noeo.svg";
import LogoNordvik from "@/images/brands/nordvik.svg";
import LogoProaktiv from "@/images/brands/proaktiv.svg";
import LogoSemJohnsen from "@/images/brands/sem-johnsen.svg";
import clsx from "clsx";
import css from "./CustomerHeader.module.scss";

type Props = {
  customer?: string;
};

export function CustomerHeader(props: Props) {
  // TEMP(scb): Show Nordvik logo + colors regardless of customer key
  // const { customer } = props;
  const customer = "nordvik" as string;

  return (
    <div className={clsx(css.root, "l-full-bleed")} data-customer={customer}>
      <div className={clsx(css.content, "l-wrapper")}>
        {customer === "aktiv" && <LogoAktiv className={css.aktivLogo} role="img" aria-label="Aktiv" />}
        {customer === "attentus" && <LogoAttentus className={css.attentusLogo} role="img" aria-label="Attentus" />}
        {customer === "eie" && (
          <>
            <LogoEie className={css.eieLogo} aria-hidden={true} />
            <span className={css.eieName}>EIE eiendomsmegling</span>
          </>
        )}
        {customer === "krogsveen" && <LogoKrogsveen className={css.krogsveenLogo} role="img" aria-label="Krogsveen" />}
        {customer === "noeo" && <LogoNOEO className={css.noeoLogo} role="img" aria-label="Norsk eiendomsoppgjør" />}
        {customer === "nordvik" && <LogoNordvik className={css.nordvikLogo} role="img" aria-label="Nordvik" />}
        {customer === "proaktiv" && <LogoProaktiv className={css.proaktivLogo} role="img" aria-label="Proaktiv" />}
        {customer === "sem-johnsen" && (
          <LogoSemJohnsen className={css.semJohnsenLogo} role="img" aria-label="Sem & Johnsen" />
        )}

        <form action={`/api/auth/logout?successUrl=${window.location.href}`} method="post">
          <button className={css.logoutLink} type="submit">
            Logg ut
          </button>
        </form>
      </div>
    </div>
  );
}
